const styles = theme => ({
  inputReusableFormControl: {
    "&:first-of-type": {
      marginTop: theme.spacing(4)
    }
  },
  subdomainContainer: {
    color: theme.palette.primary.default
  },
  labelTextColor: {
    color: theme.palette.primary.default
  },
  locationSuggestionContainer: {
    position: "absolute",
    marginTop: theme.spacing(-2),
    width: "100%",
    background: "#fff",
    boxShadow: `4px 3px 3px rgba(0, 0, 0, .3)`,
    zIndex: 5,
    maxWidth: 350
  },
  addresInput: {
    color: [theme.palette.primary.default, "!important"]
  },
  addressLabel: {
    color: [theme.palette.primary.default, "!important"]
  },
  locationSuggestion: {
    padding: `${theme.spacing(1)}px`,
    borderBottom: `1px solid rgba(0, 0, 0, 0.2)`,
    "&:last-of-type": {
      borderBottom: "none"
    },
    cursor: "pointer"
  },
  locationSuggestionActive: {
    background: "#f1f1f1"
  }
})
export default styles



// WEBPACK FOOTER //
// ./src/pages/OrganizationSignUp/steps/Step2PrimaryContact/styles.js